import ClozeSlot from './ClozeSlot';

/**
 * ClozeWord — a row of ClozeSlot pills with even gaps between them.
 *
 * Inlined styles for the same reason as ClozeSlot — guarantees the layout
 * doesn't drift from a stale stylesheet or missing Tailwind class.
 *
 * Props:
 *   surface — the full correct word, e.g. "emanates"
 *   mask    — Array<Integer>, one per character of surface;
 *             1 = revealed letter, 0 = blank.
 *             If shorter/longer/missing we fall back to "first character only".
 */
const WRAPPER_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: 'middle',
  gap: '3px',
  // See ClozeSlot — kill inherited text-indent so the row of pills
  // doesn't shift right inside text-indented prose paragraphs.
  textIndent: 0,
};

export default function ClozeWord({ surface, mask }) {
  const safeSurface = typeof surface === 'string' ? surface : '';
  if (!safeSurface) return null;

  const safeMask =
    Array.isArray(mask) && mask.length === safeSurface.length
      ? mask
      : [1, ...Array(Math.max(0, safeSurface.length - 1)).fill(0)];

  return (
    <span style={WRAPPER_STYLE}>
      {safeSurface.split('').map((ch, i) => (
        <ClozeSlot key={i} char={ch} revealed={safeMask[i] === 1} />
      ))}
    </span>
  );
}
